module.exports = {
  // apiUrl: 'http://157.245.35.24:8050/api'
  //apiUrl: 'http://localhost:8008/api'
  apiUrl: 'https://invoicesystem.travcargo.co.uk/api'
}
